.root {
    --sc-padding: rem(3px);
    --sc-shadow: var(--mantine-shadow-xs);
    background-color: light-dark(
        var(--mantine-color-gray-1),
        var(--mantine-color-dark-7)
    );
}

.indicator {
    background-color: var(--mantine-color-body);
    border: 1px solid var(--mantine-color-default-border);
}

.label {
    font-weight: 500;
    color: var(--mantine-color-dimmed);
    transition: color 120ms ease;
}

.label:hover {
    color: var(--mantine-color-text);
}

.label[data-active] {
    color: var(--mantine-color-text);
}

/* Pill lifted above the track with semantic tokens, for dark surfaces where
   the body-coloured default pill blends into its track (e.g. the navbar). */
.root[data-variant='raised'] {
    background-color: var(--mantine-color-body);
}

.root[data-variant='raised'] .indicator {
    background-color: var(--mantine-color-default-hover);
    border-color: var(--mantine-color-default-border);
}
